<template>
	<div>
		<!-- <app-header></app-header> -->
		<div class="l-container">
			<div class="privacy-info">
				<h1 class="page-tit">개인정보 처리방침</h1>
				<ul class="intro">
					<li>
						주식회사 제오젠(이하 회사)은 고객의 개인정보를 소중하게 생각하며,
						「개인정보보호법」 등 관련법규를 준수하기 위해 개인정보 처리방침을
						제정하고 이를 준수하고 있습니다.
					</li>
					<li>
						개인정보 처리방침은 법률의 제/개정, 정부의 정책 변경, 회사의 내부
						방침의 변경에 따라 바뀔 수 있습니다.
					</li>
					<li>
						회사는 개인정보 처리방침을 개정하는 경우
						회사홈페이지(www.xeogen.com)를 통하여 공지(또는 개별공지)할
						것입니다.
					</li>
					<li>회사의 개인정보 처리방침은 다음과 같은 내용을 담고 있습니다.</li>
				</ul>
				<div class="table-of-content">
					<div>
						<a href="#privacy1"
							><strong>제1조</strong>(개인정보의 수집 및 이용 목적)</a
						>
						<a href="#privacy2"
							><strong>제2조</strong>(수집하는 개인정보 항목 및 수집방법)</a
						>
						<a href="#privacy3"
							><strong>제3조</strong>(수집하는 개인정보의 보유 및 이용기간)</a
						>
						<a href="#privacy4"
							><strong>제4조</strong>(수집하는 개인정보의 파기)</a
						>
						<a href="#privacy5"
							><strong>제5조</strong>(정보주체의 권리&middot;의무 및 그
							행사방법에 관한 사항)</a
						>
					</div>
					<div>
						<a href="#privacy6"><strong>제6조</strong>(개인정보 보호책임자)</a>
						<a href="#privacy7"
							><strong>제7조</strong>(개인정보 처리방침 변경에 따른 고지)</a
						>
						<a href="#privacy8"
							><strong>제8조</strong>(개인정보의 안전성 확보조치)</a
						>
						<a href="#privacy9"><strong>제9조</strong>(권익침해 구제방법)</a>
					</div>
				</div>
				<div class="privacy-content">
					<div id="privacy1">
						<p class="tit">제1조 (개인정보의 수집 및 이용 목적)</p>
						<ul>
							<li>
								<span class="num">1.</span>회사는 다음과 같은 목적을 위하여
								개인정보를 수집합니다.
								<ul>
									<li>서비스 제공(프로젝트 문의)</li>
									<li>서비스 이행(프로젝트 문의 답변 등)</li>
								</ul>
							</li>
							<li>
								<span class="num">2.</span>단, 이용자의 기본적 인권 침해의
								우려가 있는 민감한 개인정보 (인종 및 민족, 사상 및 신조, 출신지
								및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등) 는
								수집하지 않습니다.
							</li>
						</ul>
					</div>

					<div id="privacy2">
						<p class="tit">제2조 (수집하는 개인정보 항목 및 수집방법)</p>
						<ul>
							<li>
								<span class="num">1.</span>각종 서비스 제공을 위해 아래와 같은
								개인정보를 수집하고 있습니다.
							</li>
							<!-- <li>
                            <span class="num">2.</span>Recruit<br />
                            <ul>
                                <li>개인정보 항목 : 성명, 전화번호, E-mail, 입사지원 내용, 입사지원서 첨부파일</li>
                                <li>보유근거 : 정보보호정책서 및 개인정보 보호지침</li>
                                <li>수집방법 : 인터넷 홈페이지(http://www.xeogen.com/)</li>
                            </ul>
                        </li> -->
							<li>
								<span class="num">2.</span>Project Request<br />
								<ul>
									<li>
										개인정보 항목: 성명, 소속, 전화번호, E-mail, 문의 내용, 문의
										내용 첨부파일
									</li>
									<li>보유근거 : 정보보호정책서 및 개인정보 보호지침</li>
									<li>수집방법 : 인터넷 홈페이지(http://www.xeogen.com/)</li>
								</ul>
							</li>
						</ul>
					</div>

					<div id="privacy3">
						<p class="tit">제3조 (수집하는 개인정보의 보유 및 이용기간)</p>
						<ul>
							<li>
								<span class="num">1.</span>이용자의 개인정보는 다음과 같이
								개인정보의 수집목적 또는 제공받은 목적이 달성되면 파기됩니다.
								<ul>
									<!-- <li>Recruit : 미채용 확정 시</li> -->
									<li>
										Project Request : 프로젝트 문의 완료 및 미진행 확정 시 위
										보유기간에도 불구하고 계속 보유하여야 할 필요가 있을
										경우에는 이용자의 동의를 받겠습니다.
									</li>
								</ul>
							</li>
						</ul>
					</div>

					<div id="privacy4">
						<p class="tit">제4조 (수집하는 개인정보의 파기)</p>
						<ul>
							<li>
								<span class="num">1.</span>파기 절차<br />
								<span class="grayTxt"
									>이용자가 입력한 정보는 목적 달성 후 내부 방침 및 관련 법령에
									따라 일정기간 저장된 후 혹은 즉시 파기됩니다.</span
								>
							</li>
							<li>
								<span class="num">2.</span>파기 기한<br />
								<span class="grayTxt"
									>이용자의 개인정보는 개인정보의 보유기간이 경과된 경우
									보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성
									등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가
									불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를
									파기합니다.</span
								>
							</li>
						</ul>
					</div>

					<div id="privacy5">
						<p class="tit">
							제5조 (정보주체의 권리&middot;의무 및 그 행사방법에 관한 사항)
						</p>
						<ul>
							<li>
								<span class="num">1.</span>이용자는 정보주체로서 다음과 같은
								권리를 행사할 수 있습니다.
							</li>
							<li>
								<span class="num">2.</span>개인정보 열람 요구 :
								<span class="grayTxt"
									>회사에서 보유하고 있는 개인정보는 「개인정보보호법」
									제35조(개인정보의 열람)에 따라 열람을 요구할 수 있습니다.
									개인정보 열람 요구 시 법 제35조 5항에 의하여 열람을 제한할 수
									있습니다.</span
								>
								<ul>
									<li>법률에 따라 열람이 금지되거나 제한되는 경우</li>
									<li>
										다른 사람의 생명•신체를 해할 우려가 있거나 다른 사람의
										재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우
									</li>
								</ul>
							</li>
							<li>
								<span class="num">3.</span>개인정보 정정•삭제 요구 :
								<span class="grayTxt"
									>회사에서 보유하고 있는 개인정보는 「개인정보보호법」
									제36조(개인정보의 정정&middot;삭제)에 따라 정정&middot;삭제를
									요구할 수 있습니다. 다만, 다른 법령에서 그 개인정보가 수집
									대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수
									없습니다.</span
								>
								<ul>
									<li>법률에 따라 열람이 금지되거나 제한되는 경우</li>
									<li>
										다른 사람의 생명&middot;신체를 해할 우려가 있거나 다른
										사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는
										경우
									</li>
								</ul>
							</li>
							<li>
								<span class="num">4.</span>개인정보 처리정지 요구 :
								<span class="grayTxt"
									>회사에서 보유하고 있는 개인정보는 「개인정보보호법」
									제37조(개인정보의 처리정지 등)에 따라 처리정지를 요구할 수
									있습니다. 개인정보 처리정지 요구 시 법 제37조 2항에 의하여
									처리정지 요구를 거절할 수 있습니다.</span
								>
								<ul>
									<li>
										법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여
										불가피한 경우
									</li>
									<li>
										다른 사람의 생명&middot;신체를 해할 우려가 있거나 다른
										사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는
										경우
									</li>
									<li>
										개인정보를 처리하지 아니하면 정보주체와 약정한 서비스를
										제공하지 못하는 등 계약의 이행이 곤란한 경우로서 정보주체가
										그 계약의 해지 의사를 명확하게 밝히지 아니한 경우
									</li>
								</ul>
							</li>
							<li>
								<span class="num">5.</span>개인정보 열람, 정정&middot;삭제,
								처리정지 요구는 회사의 개인정보보호 담당자에게 전화, 이메일 등을
								통해 연락하여 본인인증 절차를 거친 후 가능합니다.
							</li>
						</ul>
					</div>

					<div id="privacy6">
						<p class="tit">제6조 (개인정보 보호책임자)</p>
						<ul>
							<li>
								<span class="num">1.</span>고객의 개인정보를 보호하고 개인정보와
								관련한 불만사항 및 문의를 처리하기 위해 다음과 같이 관련부서 및
								개인정보 보호책임자를 지정하고 있습니다.
							</li>
							<li>
								<span class="num">2.</span>개인정보 보호책임자
								<ul>
									<li>성명: 박운재 팀장</li>
									<li>소속: IT개발실</li>
									<li>전화: 02) 3218-3560</li>
									<li>이메일: dallu@xeogen.com</li>
								</ul>
							</li>
							<li>
								<span class="num">3.</span>개인정보 보호담당자
								<ul>
									<li>성명: 윤영진 사원</li>
									<li>소속: 경영지원실</li>
									<li>전화: 02) 3218-3503</li>
									<li>이메일: dbsdud112@xeogen.com</li>
								</ul>
							</li>
						</ul>
					</div>

					<div id="privacy7">
						<p class="tit">제7조 (개인정보 처리방침 변경에 따른 고지)</p>
						<ul>
							<li>
								<span class="num">1.</span>이 개인정보 처리방침은 시행일로부터
								적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이
								있는 경우에는 가능한 변경사항의 시행 7일 전부터 공지사항을
								통하여 고지할 것입니다.
							</li>
							<li><span class="num">2.</span>공고일자 : 2011년 9월 30일</li>
							<li><span class="num">3.</span>시행일자 : 2011년 9월 30일</li>
						</ul>
					</div>

					<div id="privacy8">
						<p class="tit">제8조 (개인정보의 안전성 확보조치)</p>
						<ul>
							<li>
								<span class="num">1.</span>「개인정보보호법」 제29조에 따라
								다음과 같이 안전성 확보에 필요한 기술적, 관리적, 물리적 조치를
								하고 있습니다.
							</li>
							<li>
								<span class="num">2.</span>내부관리계획의 수립 및 시행
								<ul>
									<li>
										회사의 내부관리계획 수립 및 시행은 행정안전부의 내부관리
										지침을 준수하여 시행합니다.
									</li>
								</ul>
							</li>
							<li>
								<span class="num">3.</span>개인정보 처리담당자의 최소화 및 교육
								<ul>
									<li>
										개인정보를 처리하는 담당자를 지정하고 최소화하여 개인정보를
										관리하는 대책을 시행하고 있습니다.
									</li>
								</ul>
							</li>
							<li>
								<span class="num">4.</span>해킹 등에 대비한 기술적 대책
								<ul>
									<li>
										해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을
										막기 위하여 보안프로그램을 설치하고 주기적인
										갱신&middot;점검을 하며 외부로부터 접근이 통제된 구역에
										시스템을 설치하고 기술적/물리적으로 감시 및 차단하고
										있습니다. 또한 네트워크 트래픽의 통제(Monitoring)는 물론
										불법적으로 정보를 변경하는 등의 시도를 탐지하고 있습니다.
									</li>
								</ul>
							</li>
							<li>
								<span class="num">5.</span>비인가자에 대한 출입 통제
								<ul>
									<li>
										개인정보를 보관하고 있는 개인정보시스템의 물리적 보관 장소를
										별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고
										있습니다.
									</li>
								</ul>
							</li>
						</ul>
					</div>

					<div id="privacy9">
						<p class="tit">제9조 (권익침해 구제방법)</p>
						<ul>
							<li>
								<span class="num">1.</span>정보주체는 개인정보 침해로 인한
								구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원
								개인정보 침해 신고센터 등에 분쟁해결이나 상담 등을 신청할 수
								있습니다. 이 밖에 기타 개인정보 침해의 신고, 상담에 대하여는
								아래의 기관에 문의하시기 바랍니다.
							</li>
							<li>
								<span class="num">2.</span>개인분쟁조정위원회
								(www.1336.or.kr/1336)
							</li>
							<li>
								<span class="num">3.</span>정보보호마크인증위원회
								(www.eprivacy.or.kr/02-580-0533~4)
							</li>
							<li>
								<span class="num">4.</span>대검찰청 인터넷범죄수사센터
								(http://icic.sppo.go.kr/02-3480-3600)
							</li>
							<li>
								<span class="num">5.</span>경찰청 사이버테러대응센터
								(www.ctrc.go.kr/02-392-0330)
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<!-- <app-footer></app-footer> -->
	</div>
</template>

<script>
// import Header from './Header.vue';
// import Footer from './Footer.vue';

export default {
	metaInfo: {
		title: "개인정보처리방침",
	},
	data() {
		return {};
	},
	//    components: {
	//        'app-header': Header,
	//        'app-footer': Footer
	//    },
	created() {
		//console.log('xgPersonalInfo')
	},
};
</script>


// WEBPACK FOOTER //
// src/components/XgPersonalInfo.vue